import { render, staticRenderFns } from "./SendEmail.vue?vue&type=template&id=741d2f87"
import script from "./SendEmail.vue?vue&type=script&lang=js"
export * from "./SendEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('741d2f87')) {
      api.createRecord('741d2f87', component.options)
    } else {
      api.reload('741d2f87', component.options)
    }
    module.hot.accept("./SendEmail.vue?vue&type=template&id=741d2f87", function () {
      api.rerender('741d2f87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/mailbox/SendEmail.vue"
export default component.exports